const modal = "_35smkjn77s";
const smileyWrapper = "_35ss11temb0";
const textWrapper = "_35stxybv5i";
const heading = "_35sh1pgm5hs";
const errorCount = "_35sen6tk34";
const pill = "_35spbcya5v";
const remainingAttempts = "_35sr1r5w9m5";

export { errorCount, heading, modal, pill, remainingAttempts, smileyWrapper, textWrapper };
import "./task.validate-current.style.linaria.module.css";
//# sourceMappingURL=task.validate-current.style.js.map
